var _path, _path2, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 15.6471V14.3137C13.3333 13.6065 13.0524 12.9282 12.5523 12.4281C12.0522 11.928 11.3739 11.6471 10.6667 11.6471H5.33333C4.62609 11.6471 3.94781 11.928 3.44772 12.4281C2.94762 12.9282 2.66667 13.6065 2.66667 14.3137V15.6471M10.6667 6.31373C10.6667 7.78649 9.47276 8.9804 8 8.9804C6.52724 8.9804 5.33333 7.78649 5.33333 6.31373C5.33333 4.84097 6.52724 3.64706 8 3.64706C9.47276 3.64706 10.6667 4.84097 10.6667 6.31373Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69565 0.647064L1 2.28343L8.30435 3.64706L15 2.28343L7.69565 0.647064Z",
    stroke: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 2.64706,
    x2: 13.5,
    y2: 5.64706,
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 5.64706,
    r: 1,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/Students.b59d3e214243dfa9da1718a608bcc9d7.svg";
export { ForwardRef as ReactComponent };